export class ListDataCatalogDatasetEventsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "events",
            "baseName": "events",
            "type": "Array<DataCatalogDatasetEvent>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogDatasetEventsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
